import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col, Modal, Spinner, Form, Button, Card } from "react-bootstrap";
import Select from 'react-select';
import empresas from 'api/empresas';
import { AccountContext } from 'components/Account/Account';
import generarDocumentoManual from 'api/generarDocumentoManual';
import getDevicesByTenant from 'api/getDevicesByTenant';

const GenerarDocumentoManual = () => {

    const { getSession } = useContext(AccountContext);

    const [empresaList, setEmpresaList] = useState([]);
    const [rut, setRut] = useState('');
    const [tenantId, setTenantId] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState(39);
    const [valorTotal, setValorTotal] = useState('');
    const [valorNeto, setValorNeto] = useState('');
    const [valorIva, setValorIva] = useState('');
    const [fechaEmision, setFechaEmision] = useState(new Date().toISOString().slice(0, 10));
    const [horaEmision, setHoraEmision] = useState(new Date().toTimeString().slice(0, 5));
    const [nombre, setNombre] = useState('');
    const [descAdicional, setDescAdicional] = useState('');
    const [tipoPago, setTipoPago] = useState('efectivo');
    const [deviceId, setDeviceId] = useState('');
    const [deviceOptions, setDeviceOptions] = useState([]);
    const [deviceLoading, setDeviceLoading] = useState(false);
    const [autoCalcMontos, setAutoCalcMontos] = useState(true);
    const [ivaPercent, setIvaPercent] = useState(19);

    const [show, setShow] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [responseData, setResponseData] = useState(null);

    const formatMiles = (value) => {
        if (value === '' || value === null || value === undefined) return '';
        const num = Number(value);
        if (isNaN(num)) return '';
        return num.toLocaleString('es-CL');
    };

    const parseMiles = (str) => {
        const digits = String(str).replace(/\D/g, '');
        return digits === '' ? '' : Number(digits);
    };

    const formatHoraMask = (str) => {
        let digits = String(str).replace(/\D/g, '').slice(0, 4);
        if (digits.length === 0) return '';
        if (digits[0] > '2') digits = '2' + digits.slice(1);
        if (digits.length >= 2) {
            let h1 = digits[1];
            if (digits[0] === '2' && h1 > '3') h1 = '3';
            digits = digits[0] + h1 + digits.slice(2);
        }
        if (digits.length >= 3) {
            let m0 = digits[2];
            if (m0 > '5') m0 = '5';
            digits = digits.slice(0, 2) + m0 + digits.slice(3);
        }
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}:${digits.slice(2)}`;
    };

    const HORA_24H_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

    const TEXTO_REGEX = /^[A-Za-zÑñ0-9\s.,\-/#()º]*$/;

    const limpiarTildesYApostrofes = (value) => {
        if (typeof value !== 'string') return value;
        return value
            .replace(/['‘’ʼʻ`´]/g, '')
            .split('')
            .map((ch) => {
                if (ch === 'ñ' || ch === 'Ñ') return ch;
                return ch.normalize('NFD').replace(/[̀-ͯ]/g, '');
            })
            .join('');
    };

    const optionsdoc = [
        { value: 39, label: '39 - Boleta Electrónica' },
        { value: 41, label: '41 - Boleta Exenta' },
    ];

    const optionsTipoPago = [
        { value: 'efectivo', label: '1 - Efectivo' },
        { value: 'tarjeta', label: '2 - Tarjeta' },
       
    ];

    const empresaOptions = empresaList
        // .filter((e) => e.rut !== 1 && e.rut !== '1')
        .map((e) => ({
            value: e.rut,
            label: e.rut + ' - ' + e.name + (e.status === 'suspended' ? ' (Deshabilitada)' : ''),
            tenant_id: e.tenant_id,
            status: e.status,
            isDisabled: e.status === 'suspended',
        }));

    useEffect(() => {
        getSession().then((session) => {
            empresas.getEmpresas(session.idToken.jwtToken)
                .then((response) => {
                    setEmpresaList(response.data);
                })
                .catch((error) => {
                    if (axios.isCancel(error)) return false;
                    console.log(error);
                });
        });
    }, []);

    useEffect(() => {
        async function fetchDevices() {
            if (!tenantId) {
                setDeviceOptions([]);
                setDeviceId('');
                return;
            }
            setDeviceLoading(true);
            setDeviceOptions([]);
            setDeviceId('');
            try {
                const idToken = await getSession().then((session) => session.idToken.jwtToken);
                const response = await getDevicesByTenant(idToken, tenantId);
                const records = response.data.records || response.data || [];
                const options = records.map((d) => {
                    const name = d.device_name || d.name || d.deviceName || '';
                    return {
                        value: d.device_id,
                        label: name ? `${d.device_id} - ${name}` : d.device_id,
                    };
                });
                setDeviceOptions(options);
            } catch (error) {
                console.log(error);
                setDeviceOptions([]);
            } finally {
                setDeviceLoading(false);
            }
        }
        fetchDevices();
    }, [tenantId]);

    const handleClose = () => {
        setShow(false);
    };

    const validarCampos = () => {
        if (!rut) return 'Por favor seleccione una empresa';
        const empresaSel = empresaList.find((e) => e.rut === rut);
        if (empresaSel && empresaSel.status === 'suspended') {
            return 'La empresa seleccionada está deshabilitada. No es posible generar documentos.';
        }
        if (!tipoDocumento) return 'Por favor seleccione un tipo de documento';
        if (valorTotal === '' || isNaN(Number(valorTotal))) return 'Ingrese un valor total válido';
        if (valorNeto === '' || isNaN(Number(valorNeto))) return 'Ingrese un valor neto válido';
        if (valorIva === '' || isNaN(Number(valorIva))) return 'Ingrese un valor IVA válido';
        if (!fechaEmision) return 'Ingrese la fecha de emisión';
        const hoy = new Date().toISOString().slice(0, 10);
        if (fechaEmision > hoy) return 'La fecha de emisión no puede ser mayor al día actual';
        if (!horaEmision) return 'Ingrese la hora de emisión';
        if (!HORA_24H_REGEX.test(horaEmision)) return 'La hora de emisión debe estar en formato HH:MM (24h)';
        if (!tipoPago) return 'Seleccione el tipo de pago';
        if (!deviceId) return 'Ingrese el device_id';
        if (nombre && !TEXTO_REGEX.test(nombre)) {
            return 'El nombre contiene caracteres no permitidos (tildes o caracteres especiales).';
        }
        if (descAdicional && !TEXTO_REGEX.test(descAdicional)) {
            return 'La descripción adicional contiene caracteres no permitidos (tildes o caracteres especiales).';
        }
        return null;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const error = validarCampos();
        if (error) {
            setSuccess(false);
            setMessage(error);
            setLoading(false);
            setShow(true);
            return;
        }

        setShowConfirm(true);
    };

    const handleConfirmSubmit = async () => {
        setShowConfirm(false);
        setLoading(true);
        setShow(true);

        const params = {
            rut,
            tipoDocumento: Number(tipoDocumento),
            valorTotal: Number(valorTotal),
            valorNeto: Number(valorNeto),
            valorIva: Number(valorIva),
            fechaEmision,
            horaEmision,
            nombre,
            descAdicional,
            tipoPago,
            device_id: deviceId,
        };

        try {
            const idToken = await getSession().then((session) => session.idToken.jwtToken);
            const resp = await generarDocumentoManual(params, idToken);
            console.log(resp);
            let body = resp.data;
            if (body && typeof body.body === 'string') {
                try { body = JSON.parse(body.body); } catch (_) { /* deja body tal cual */ }
            }
            setResponseData(body || {});
            setSuccess(true);
            setMessage('Documento generado correctamente');
            setLoading(false);
        } catch (err) {
            console.log(err);
            setSuccess(false);
            setResponseData(null);
            const apiMsg = err?.response?.data?.message || err?.message || 'Error al generar el documento';
            setMessage('Error al generar el documento: ' + apiMsg);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!autoCalcMontos) return;
        if (valorTotal === '' || isNaN(Number(valorTotal))) {
            setValorNeto('');
            setValorIva('');
            return;
        }
        const totalNum = Number(valorTotal);
        if (Number(tipoDocumento) === 41) {
            setValorNeto(totalNum);
            setValorIva(0);
            return;
        }
        const ivaPct = Number(ivaPercent) || 0;
        const neto = Math.round(totalNum / (1 + ivaPct / 100));
        setValorNeto(neto);
        setValorIva(totalNum - neto);
    }, [valorTotal, ivaPercent, tipoDocumento, autoCalcMontos]);

    return (
        <>
            <Container fluid className="page-container">
                <div className="page-header">
                    <div>
                        <h2 className="page-title">Documento manual</h2>
                        <p className="page-subtitle">
                            Genera manualmente un documento (boleta) para una empresa y dispositivo.
                        </p>
                    </div>
                </div>

                <Card className="data-card">
                    <Card.Body>
                        <Form onSubmit={handleSubmit} className="filter-form">
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Empresa</Form.Label>
                                        <Select
                                            options={empresaOptions}
                                            onChange={(opt) => {
                                                setRut(opt.value);
                                                setTenantId(opt.tenant_id);
                                            }}
                                            placeholder="Seleccione empresa"
                                            classNamePrefix="rs"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Tipo de documento</Form.Label>
                                        <Select
                                            options={optionsdoc}
                                            defaultValue={optionsdoc[0]}
                                            onChange={(opt) => setTipoDocumento(opt.value)}
                                            classNamePrefix="rs"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="form-field">
                                        <Form.Label>&nbsp;</Form.Label>
                                        <label className="check-inline check-inline--block">
                                            <input
                                                type="checkbox"
                                                id="autoCalcMontos"
                                                checked={autoCalcMontos}
                                                onChange={(e) => setAutoCalcMontos(e.target.checked)}
                                            />
                                            <span>Calcular neto e IVA automáticamente</span>
                                        </label>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="form-field">
                                        <Form.Label>IVA (%)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            value={ivaPercent}
                                            onChange={(e) => setIvaPercent(e.target.value)}
                                            disabled={!autoCalcMontos || Number(tipoDocumento) === 41}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={4}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Valor total</Form.Label>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            value={formatMiles(valorTotal)}
                                            onChange={(e) => setValorTotal(parseMiles(e.target.value))}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Valor neto</Form.Label>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            value={formatMiles(valorNeto)}
                                            onChange={(e) => setValorNeto(parseMiles(e.target.value))}
                                            disabled={autoCalcMontos}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Valor IVA</Form.Label>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            value={formatMiles(valorIva)}
                                            onChange={(e) => setValorIva(parseMiles(e.target.value))}
                                            disabled={autoCalcMontos}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={4}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Fecha de emisión</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={fechaEmision}
                                            max={new Date().toISOString().slice(0, 10)}
                                            onChange={(e) => setFechaEmision(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Hora de emisión (HH:MM)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={5}
                                            placeholder="HH:MM"
                                            value={horaEmision}
                                            onChange={(e) => setHoraEmision(formatHoraMask(e.target.value))}
                                            isInvalid={horaEmision !== '' && !HORA_24H_REGEX.test(horaEmision)}
                                            isValid={horaEmision !== '' && HORA_24H_REGEX.test(horaEmision)}
                                        />
                                        {horaEmision !== '' && !HORA_24H_REGEX.test(horaEmision) && (
                                            <small className="field-hint field-hint--error">
                                                Formato inválido. Use HH:MM (24h).
                                            </small>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Tipo de pago</Form.Label>
                                        <Select
                                            options={optionsTipoPago}
                                            defaultValue={optionsTipoPago[0]}
                                            onChange={(opt) => setTipoPago(opt.value)}
                                            classNamePrefix="rs"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Nombre producto / servicio</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={nombre}
                                            onChange={(e) => setNombre(limpiarTildesYApostrofes(e.target.value))}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Descripción adicional</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={descAdicional}
                                            onChange={(e) => setDescAdicional(limpiarTildesYApostrofes(e.target.value))}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Device</Form.Label>
                                        <Select
                                            options={deviceOptions}
                                            value={deviceOptions.find((o) => o.value === deviceId) || null}
                                            onChange={(opt) => setDeviceId(opt ? opt.value : '')}
                                            isLoading={deviceLoading}
                                            isDisabled={!rut || deviceLoading}
                                            placeholder={!rut ? 'Seleccione una empresa primero' : 'Seleccione un device'}
                                            noOptionsMessage={() => 'Sin devices para esta empresa'}
                                            classNamePrefix="rs"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="form-submit">
                                <Button type="submit" className="btn-primary-action btn-primary-action--inline">
                                    <i className="nc-icon nc-ruler-pencil" />
                                    Generar documento
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>

            <Modal show={showConfirm} onHide={() => setShowConfirm(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar envío del documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="modal-intro">Revisa los datos antes de generar:</p>
                    <div className="confirm-grid">
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Empresa (RUT)</span><span className="confirm-grid__value">{rut}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Tipo de documento</span><span className="confirm-grid__value">{optionsdoc.find((o) => o.value === Number(tipoDocumento))?.label || tipoDocumento}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Valor total</span><span className="confirm-grid__value">{formatMiles(valorTotal)}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Valor neto</span><span className="confirm-grid__value">{formatMiles(valorNeto)}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Valor IVA</span><span className="confirm-grid__value">{formatMiles(valorIva)}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Fecha emisión</span><span className="confirm-grid__value">{fechaEmision}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Hora emisión</span><span className="confirm-grid__value">{horaEmision}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Nombre producto/servicio</span><span className="confirm-grid__value">{nombre || <em className="text-muted">(vacío)</em>}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Descripción adicional</span><span className="confirm-grid__value">{descAdicional || <em className="text-muted">(vacío)</em>}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Tipo de pago</span><span className="confirm-grid__value">{optionsTipoPago.find((o) => o.value === tipoPago)?.label || tipoPago}</span></div>
                        <div className="confirm-grid__row"><span className="confirm-grid__label">Device</span><span className="confirm-grid__value">{deviceOptions.find((o) => o.value === deviceId)?.label || deviceId}</span></div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                        Cancelar
                    </Button>
                    <Button className="btn-primary-action btn-primary-action--inline" onClick={handleConfirmSubmit}>
                        Confirmar y generar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={handleClose} backdrop="static" centered>
                <Modal.Header closeButton={!loading}>
                    <Modal.Title>
                        {loading ? 'Generando documento' : success ? 'Documento generado' : 'Error'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div className="result-loading">
                            <Spinner animation="border" role="status" />
                            <span>Procesando...</span>
                        </div>
                    ) : success ? (
                        <div className="result-grid">
                            <div className="result-grid__header">
                                <span className="result-grid__folio-label">Estado</span>
                                <span className="status-badge status-badge--success">{message}</span>
                            </div>
                            {responseData && (
                                <>
                                    <div className="result-grid__row">
                                        <span className="result-grid__label">Rut</span>
                                        <span className="result-grid__value">{rut}</span>
                                    </div>
                                    <div className="result-grid__row">
                                        <span className="result-grid__label">Tipo documento</span>
                                        <span className="result-grid__value">{tipoDocumento}</span>
                                    </div>
                                    {responseData.folio !== undefined && (
                                        <div className="result-grid__row">
                                            <span className="result-grid__label">Folio</span>
                                            <span className="result-grid__value">{responseData.folio}</span>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    ) : (
                        <div className="result-error">{message}</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!loading && (
                        <Button variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GenerarDocumentoManual;
